<template>
  <div class="m-ip-select">
    <label class="m-ip-select__label" v-if="slotPassed">
      <slot></slot>
    </label>

    <input type="hidden" v-model="ipValue" />
    <button
      class="m-ip-select__trigger"
      :class="{
        'm-ip-select__trigger--placeholder':
          this.triggerLabel === this.placeholder,
      }"
      type="button"
      @click="toggleOptions"
    >
      <span class="m-ip-select__trigger-label">{{ triggerLabel }}</span>
    </button>
    <ul
      class="m-ip-select__options-wrapper"
      :class="{ 'is-open': this.optionsVisible }"
    >
      <li
        class="m-ip-select__option m-ip-select__option--placeholder"
        @click="selectOption('-1')"
      >
        {{ placeholder }}
      </li>
      <li
        v-for="opt in options"
        :key="opt.value"
        class="m-ip-select__option"
        @click="selectOption(opt.value)"
      >
        {{ opt.label }}
      </li>
    </ul>

    <div class="m-ip-select__overlay" @click="this.hideOptions"></div>
  </div>
</template>

<script>
export default {
  name: "IpSelect",
  props: {
    options: {
      type: Array,
    },
    placeholder: String,
    value: String,
  },
  data() {
    return {
      optionsVisible: false,
    };
  },
  computed: {
    slotPassed() {
      return this.$slots.default;
    },
    ipValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value.toString());
      },
    },
    triggerLabel() {
      let label = this.placeholder;

      if (!this.value) {
        return label;
      }

      this.options.forEach((opt) => {
        if (opt.value.toString() === this.value) {
          label = opt.label;
        }
      });

      return label;
    },
  },
  methods: {
    hideOptions() {
      this.optionsVisible = false;
    },
    toggleOptions() {
      this.optionsVisible = !this.optionsVisible;
    },
    selectOption(value) {
      this.ipValue = value;
      this.hideOptions();
    },
  },
  mounted() {
    console.log(this.$slots);
  },
};
</script>
